import { type SanityFrameBuilderExtraService } from '../data/sanity/queries/types/extra-services'
import { type SanityFrameBuilderGlass } from '../data/sanity/queries/types/glass'
import {
  type SanityFrameBuilderPassepartoutColor,
  type SanityFrameBuilderPassepartoutSize,
} from '../data/sanity/queries/types/passepartout'
import { type SanityFrameBuilderProfile } from '../data/sanity/queries/types/profile'
import { type SanityFrameBuilderServicePrices } from '../data/sanity/queries/types/service-prices'
import {
  type SanityFrameBuilderSpacerColor,
  type SanityFrameBuilderSpacerSize,
} from '../data/sanity/queries/types/spacer'
import {
  type SanityFrameBuilderStandardSize,
  type SanityFrameBuilderStandardSizeFramePriceReference,
} from '../data/sanity/queries/types/standard-size'
import { type SanityFrameBuilderTexture } from '../data/sanity/queries/types/texture'

export type FrameBuilderProfile = SanityFrameBuilderProfile

export type FrameBuilderTexture = SanityFrameBuilderTexture

export type FrameBuilderPassepartoutSize = SanityFrameBuilderPassepartoutSize

export type FrameBuilderPassepartoutColor = SanityFrameBuilderPassepartoutColor

export type FrameBuilderGlass = SanityFrameBuilderGlass

export type FrameBuilderSpacerSize = SanityFrameBuilderSpacerSize

export type FrameBuilderSpacerColor = SanityFrameBuilderSpacerColor

export type FrameBuilderExtraService = SanityFrameBuilderExtraService

export type FrameBuilderServicePrices = SanityFrameBuilderServicePrices

export type FrameBuilderStandardSize = SanityFrameBuilderStandardSize

export type FrameBuilderStandardSizeFramePriceReference =
  SanityFrameBuilderStandardSizeFramePriceReference

export interface FrameBuilderArtworkImage {
  url: string
  name: string
}

interface FrameBuilderArtworkBackgroundColor {
  current?: string
  predefinedColors?: string[]
}

interface FrameBuilderArtworkState {
  width: number
  height: number
  image?: FrameBuilderArtworkImage
  backgroundColor?: FrameBuilderArtworkBackgroundColor
}

interface FrameBuilderPassepartoutState {
  size?: FrameBuilderPassepartoutSize
  color?: FrameBuilderPassepartoutColor
}

interface FrameBuilderExtrasState {
  active: boolean
  extraServices?: FrameBuilderExtraService[]
  spacer: {
    size?: FrameBuilderSpacerSize
    color?: FrameBuilderSpacerColor
  }
}

export interface FrameBuilderState {
  artwork: FrameBuilderArtworkState
  texture?: FrameBuilderTexture
  profile?: FrameBuilderProfile
  passepartout: FrameBuilderPassepartoutState
  glass?: FrameBuilderGlass
  extras: FrameBuilderExtrasState
}

export const emptyFrameBuilderState: FrameBuilderState = {
  artwork: {
    width: 0,
    height: 0,
  },
  texture: undefined,
  profile: undefined,
  passepartout: {
    size: undefined,
    color: undefined,
  },
  glass: undefined,
  extras: {
    active: false,
    extraServices: [],
    spacer: {
      size: undefined,
      color: undefined,
    },
  },
}
